/* Welcome / first-visit popup — ₹500 OFF coupon with email capture.
   Triggers once per browser (localStorage flag). */
import { useEffect, useState } from "react";
import { X, Sparkles } from "lucide-react";
import { api, formatApiErr } from "@/lib/api";
import { toast } from "sonner";

const KEY = "vv_welcome_seen_v1";
const COUPON = "VEDIC500";

export default function WelcomePopup() {
    const [open, setOpen] = useState(false);
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [revealed, setRevealed] = useState(false);

    useEffect(() => {
        if (localStorage.getItem(KEY)) return;
        const t = setTimeout(() => setOpen(true), 6500);
        return () => clearTimeout(t);
    }, []);

    const close = () => {
        localStorage.setItem(KEY, "1");
        setOpen(false);
    };

    const claim = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/newsletter", { email });
            setRevealed(true);
            toast.success("Welcome aboard! Your ₹500 OFF code is below.");
        } catch (err) {
            toast.error(formatApiErr(err));
        } finally {
            setLoading(false);
        }
    };

    if (!open) return null;
    return (
        <div className="fixed inset-0 z-[80] grid place-items-center px-4 bg-black/70 backdrop-blur-sm animate-in fade-in" data-testid="welcome-popup">
            <div className="relative w-full max-w-md rounded-3xl border border-gold/40 bg-ink-deep p-8 shadow-2xl">
                <button onClick={close} className="absolute top-4 right-4 text-cream-muted hover:text-gold" data-testid="welcome-popup-close" aria-label="Close">
                    <X className="h-5 w-5" />
                </button>
                <div className="flex justify-center mb-4">
                    <div className="h-16 w-16 rounded-full bg-gold/15 border border-gold/40 grid place-items-center">
                        <Sparkles className="h-8 w-8 text-gold" />
                    </div>
                </div>
                <h3 className="font-serif text-2xl text-cream text-center leading-tight">A Cosmic Welcome 🪔</h3>
                <p className="text-sm text-cream-muted text-center mt-3 leading-relaxed">
                    Join 12,000+ seekers. Get an instant <strong className="text-gold">₹500 OFF</strong> any consultation, plus monthly horoscope & remedies.
                </p>

                {!revealed ? (
                    <form onSubmit={claim} className="mt-6 space-y-3">
                        <input
                            type="email"
                            required
                            placeholder="your@email.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="input-luxe text-sm"
                            data-testid="welcome-popup-email"
                        />
                        <button type="submit" disabled={loading} className="btn-gold w-full text-sm disabled:opacity-50" data-testid="welcome-popup-submit">
                            {loading ? "Sending..." : "Claim My ₹500 Off"}
                        </button>
                        <button type="button" onClick={close} className="w-full text-xs text-cream-dim hover:text-gold py-2" data-testid="welcome-popup-skip">
                            No thanks
                        </button>
                    </form>
                ) : (
                    <div className="mt-6 text-center">
                        <div className="rounded-2xl border-2 border-dashed border-gold/60 bg-gold/5 py-5 px-4">
                            <div className="label-eyebrow text-xs">Your code</div>
                            <div className="font-serif text-3xl text-gold mt-2 tracking-widest" data-testid="welcome-popup-coupon">{COUPON}</div>
                            <p className="text-xs text-cream-muted mt-3">Apply at checkout. Valid 7 days.</p>
                        </div>
                        <button onClick={close} className="btn-outline-gold mt-5 text-sm w-full" data-testid="welcome-popup-done">
                            Got it
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}
